import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Tahir Khan </span>
            from <span className="purple"> Nagpur, India.</span>
            <br />
            I am currently employed as a software developer at Fudugo Solutions.
            <br />
            I have completed Integrated B.Tech in Computer Science at GCOEJ.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Reading Fictional Novels
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Startup Stories
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing Video Games
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Always give your best to make a difference"{" "}
          </p>
          <footer className="blockquote-footer">Tahir</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
